import { FC, memo } from 'react';
import { NormalPriceProps } from './NormalPrice.types';
import styles from './NormalPrice.module.scss';
import classNames from 'classnames';

const NormalPrice = memo((props: NormalPriceProps) => {
  const { fontSize, lineThrough = false, showDecimal = false, isDisable = false } = props;
  const [IntPrice, decimalPrice] = (props?.price || 0).toString().split('.');
  return (
    <span
      className={classNames(
        lineThrough && styles.line_through,
        styles[`font_${fontSize}`],
        isDisable && styles.disable
      )}
    >
      {fontSize === 16
        ? `HK$ ${Number(IntPrice).toLocaleString()}`
        : `HK$${Number(IntPrice).toLocaleString()}`}
      {(showDecimal || decimalPrice) && `.${decimalPrice || '00'}`}
    </span>
  );
});
export default NormalPrice;
